// extracted by mini-css-extract-plugin
export default {"popupOverlay":"BasicPopup_popupOverlay__dWMVV","popup":"BasicPopup_popup__uMisx"};